import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../base";
import { useFormFieldContext } from "../context";

function FormH1Preview({ ...props }) {
  const { field: { label } } = useFormFieldContext()

  return <BasePreview {...props}>
    <h1>{label}</h1>
  </BasePreview>
}

export default define('form-heading-h1', FormH1Preview, Fragment)
  .shared(prop.share('FormH1', 'form-heading-h1'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()

